<template>
  <!-- 找律师 -->
  <div id="findLawyers">
    <div class="findlaw_fluid_banner w_100">
      <el-carousel
        class="findswipe"
        trigger="click"
        height="430px"
        arrow="never"
      >
        <el-carousel-item v-for="item in 4" :key="item">
          <img src="~assets/findlawyers/banner_sample.png" class="img" />
        </el-carousel-item>
      </el-carousel>
	  <div class="banner_other flex between">
	  	<div class="chooselist flex-col">
	  		<div class="choosetop">
	  			<span :class="['mr20',showarea?'':'active']" @click="clickitem(false)">按专长找</span> | 
				<span :class="['ml20',showarea?'active':'']" @click="clickitem(true)">按地区找</span>
	  		</div>
			<ul class="thelist " v-if="!showarea">
				<li v-for="(item,index) in 8" :class="['flex',workindex == index?'active':''] " 
				@mouseenter="towork(index)"
				@mouseleave="workindex = Infinity"
				>
					<img src="../../assets/findlawchild/locfirgengduo.png" :style="workindex == index?'':'opacity:.42'" >
					<span>婚姻家庭</span>
				</li>
			</ul>
			<ul class="arealist flex wrap" v-if="showarea">
				<li :class="areaindex == index?'active':''" v-for="(item,index) in 10" 
				@mouseenter="toarea(index,0)"
				@mouseleave="areaindex = Infinity"
				>合肥市</li>
			</ul>
				<span class="tit active" v-if="showarea">热门地区</span>
			<ul class="hotlist flex wrap" v-if='showarea' >
				
				<li :class="hotindex == index?'active':''" v-for="(item,index) in 12" 
				@mouseenter="toarea(index,1)"
				@mouseleave="hotindex = Infinity"
				>北京</li>
			</ul>
	  	</div>
		<div class="findme flex-col">
			<img class="dw" src="../../assets/findlawyers/dw.png" >
			<button type="button">进入合肥站</button>
			<div class="theinput ">
				<input type="text" id="" placeholder="请输入律师姓名" value="" />
				<div class="innerbox flex center">
					<i class="el-icon-search"></i>
				</div>
			</div>
			<span class="FontSize18 FontBlack">遇事找律观</span>
			<img class="mt20" src="../../assets/findlawyers/qrcode.png" style="width: 64px;">
			<span class="FiseSize14 FontGray mt10">微信扫一扫随时找律师</span>
		</div>
	  </div>
	  
    </div>

    <section><findlawyerhfyxls /></section>


    <section><findlawyerhfrmzx /></section>

    <section><findlawyerawtzhfls /></section>

    <section><findlawyerazyzhfls /></section>

    <section><findlawyerhflss /></section>

    <section class="findlawyerjxflzs w_100"><findlawyerjxflzs /></section>

    <section><findlawyerpfzs /></section>

    <section><findlawyerflsphb /></section>

    <section><findlawyerzbflfw /></section>
  </div>
</template>

<script>
import findlawyerhfyxls from "./child/hfyxls"; //合肥优选律师
import findlawyerhfrmzx from "./child/hfrmzx"; //合肥热门咨询
import findlawyerawtzhfls from "./child/awtzhfls"; //按问题找合肥律师
import findlawyerazyzhfls from "./child/azyzhfls"; //按专业找合肥律师
import findlawyerhflss from "./child/hflss"; //合肥律师事务所
import findlawyerjxflzs from "./child/jxflzs"; //精选法律知识
import findlawyerpfzs from "./child/qestpfzs"; //普法知识
import findlawyerflsphb from "./child/qesthflsphb"; //合肥律师排行榜
import findlawyerzbflfw from "./child/qestzbflfw"; //周边法律服务

export default {
  name: "findLawyers",

  components: {
    findlawyerhfyxls,
    findlawyerhfrmzx,
    findlawyerawtzhfls,
    findlawyerazyzhfls,
    findlawyerhflss,
    findlawyerjxflzs,
    findlawyerpfzs,
    findlawyerflsphb,
    findlawyerzbflfw,
  },
  data(){
	  return{
		  showarea:true,
		  areaindex:Infinity,
		  hotindex:Infinity,
		  workindex:Infinity
	  }
  },
  methods:{
	  clickitem(bool){
		  this.showarea = bool
	  },
	  towork(index){
		  this.workindex = index
	  },
	  toarea(index,val){
		  console.log(index)
		  if(val){
			  this.hotindex = index
			  this.areaindex = Infinity
		  }else{
			  this.areaindex = index
			  this.hotindex = Infinity
		  }
	  }
  }
};
</script>

<style lang="scss" scope>
#findLawyers {
  background-color: #fff;
  .findlawyerjxflzs {
    background-color: #f8f8f8;
  }
  .findlaw_fluid_banner {
    position: relative;
    height: 430px;
    .findswipe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      .img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .banner_other{
	  position: absolute;
	  z-index: 99;
	  width: 1200px;
	  margin-left: -600px;
	  left: 50%;
	  .chooselist{
		  width: 220px;
		  height: 430px;
		  background: #000000;
		  background-color: rgba(39,41,53,.42);
		  // opacity: 0.42;
		  color: #bbbbbb;
		  padding-top: 24px;
		  .choosetop{
			  text-align: center;
			  cursor: pointer;
		  }
		  .thelist{
			  padding-left: 30px;
			  li{
				  margin-top: 20px;
				  align-items: center;
				  cursor: pointer;
			  }
			  img{
				  width: 20px;
				  object-fit: contain;
				  margin-right: 22px;
			  }
		  }
		  .arealist{
			  margin: 20px 0;
			  padding-left: 15px;
			  justify-content: space-between;
			  li{
				  margin-right: 15px;
				  margin-bottom: 10px;
				  cursor: pointer;
			  }
			  
		  }
		  .arealist::after{
			  content: '_____________________';
		  }
		  .tit{
			  padding-left: 15px;
			  opacity: 1!important;
		  }
		  .hotlist{
			  margin: 15px 0;
			  padding-left: 15px;
			  justify-content: space-between;
			  li{
				  margin-right: 15px;
				  margin-bottom: 10px;
				  cursor: pointer;
			  }
		  }
		  .active{
			  color: #ffffff;
		  }
	  }
	  .findme{
		  width: 200px;
		  height: 351px;
		  background: #FFFFFF;
		  align-items: center;
		  padding: 30px 0;
		  background-image: url(../../assets/findlawyers/图层%201171.png);
		  background-position: left top;
		  background-size: contain;
		  background-repeat: no-repeat;
		  .dw{
			  width: 27px;
			  object-fit: contain;
			  margin-bottom: 18px;
		  }
		  button{
			  width: 142px;
			  height: 28px;
			  background: #0465EA;
			  border-radius: 14px;
			  border: none;
			  color: #fff;
			  margin-bottom: 13px;
		  }
		  .theinput{
			  position: relative;
			  width: 142px;
			  height: 28px;
			  background: #FFFFFF;
			  border: 1px solid #EEEEEE;
			  border-radius: 14px;
			  margin-bottom: 30px;
			  input{
				  width: 110px;
				  padding-left: 5px;
				  border: none;
			  }
			  input:focus{
				  outline: none;
			  }
			  .innerbox{
				  position: absolute;
				  top: 0;
				  right: 0;
				 width: 36px;
				 height: 28px;
				 background: #B0B4BD;
				 border-radius: 14px;
				 color: #fff;
			  }
		  }
		  .theinput::after{
			  content: '________________';
			  color: #eeeeee;
		  }
	  }
  }
}
</style>